export default {
  namespaced: true,

  state: {
    isShown: false,
    header: '',
    text: '',
    component: '',
    props: {},
  },

  mutations: {
    SHOW_DIALOG(state, payload) {
      state.header = payload.header;
      state.text = payload.text;
      state.component = payload.component;
      state.isShown = true;
      state.props = payload.props;
    },
    CLEAR_DIALOG(state) {
      state.isShown = false;
      state.header = '';
      state.text = '';
      state.component = '';
      state.props = {};
    },
  },

  actions: {
    showDialog({ commit }, payload) {
      commit('SHOW_DIALOG', payload);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    clearDialog({ commit }) {
      commit('CLEAR_DIALOG');
    },

    confirm({ commit }) {
      this.resolve(true);
      commit('CLEAR_DIALOG');
    },

    cancel({ commit }) {
      this.reject(false);
      commit('CLEAR_DIALOG');
    },
  },
};
